<!-- @Version 1.0.1 -->
<div class="one-row-element" [attr.color]="sFieldItem.getColor(fieldItem.attribute_1!, COLOR.DISABLED)">
   <h2 class="title-second" data-testid="header2" [style.text-align]="fieldItem.attribute_2 | posAndColor : 1 : POSITION.LEFT" [attr.color]="fieldItem.attribute_1 | posAndColor : 2 : COLOR.DISABLED" [innerHTML]="fieldItem.attribute_3"></h2>
</div>
